/* eslint-disable prettier/prettier */
import styled, { css } from 'styled-components';

// COLORS
import { theme } from '../../constants/theme';

//Interface
import { IKebab, IKebabProps } from '../../interfaces/Kebab.interface';

// ENUMS
import { sideKebab } from '../../enums/sideKebab';

export const ContainerKebab = styled.div`
  position: relative;
  display: inline-block;
  min-width: 10px;
`;

export const ContainerIcon = styled.div<IKebab>`
  cursor: pointer;
  border: 1px solid ${theme.colors.primary.white};
  box-sizing: border-box;
  border-radius: 4px;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ big }) =>
    big &&
    css`
      width: 42px;
      height: 42px;
      border-radius: 8px;
    `}

  ${({ gray }) =>
    gray &&
    css`
      border: 1px solid ${theme.colors.secondary.gray400};
    `}

  ${({ isOpen, gray }) =>
    !isOpen &&
    !gray &&
    css`
      &:hover {
        background-color: ${theme.colors.secondary.blue600};
        border: 1px solid ${theme.colors.secondary.blue500};
        svg {
          fill: ${theme.colors.primary.bariBlue};
          path {
            fill: ${theme.colors.primary.bariBlue};
          }
        }
      }
    `}

  ${({ isOpen, gray }) =>
    !isOpen &&
    gray &&
    css`
      &:hover {
        background-color: ${theme.colors.secondary.blue600};
        border: 1px solid ${theme.colors.secondary.blue500};
        svg {
          fill: ${theme.colors.primary.bariBlue};
          path {
            fill: ${theme.colors.primary.bariBlue};
          }
        }
      }
    `}

  ${({ isOpen }) =>
    isOpen &&
    css`
      border: 1px solid ${theme.colors.primary.bariBlue};
      svg {
        fill: ${theme.colors.primary.bariBlue};
        path {
          fill: ${theme.colors.primary.bariBlue};
        }
      }
    `}
`;

export const Options = styled.div<IKebabProps>`
  position: absolute;
  background-color: ${theme.colors.primary.white};
  width: 267px;
  box-sizing: border-box;
  box-shadow: 20px 0px 30px -10px rgba(0, 0, 0, 0.07), -20px 0px 20px -10px rgba(0, 0, 0, 0.07),
    0px 20px 30px -10px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  ${({ side }) =>
    side == sideKebab.LEFT &&
    css`
      right: 0px;
    `}
  ${({ side }) =>
    side == sideKebab.RIGHT &&
    css`
      left: 0px;
    `}  
  top: 38px;
  z-index: 999;
  ${({ big }) =>
    big &&
    css`
      top: 52px;
    `}
`;

export const ContentKebab = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
`;

export const ItemKebab = styled.ul`
  padding: 18px 26px;
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  line-height: 24px;
  color: ${theme.colors.secondary.gray100};
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.regular};
  align-items: center;
  border-top: 1px solid ${theme.colors.primary.transparentBg};

  &:hover {
    background: ${theme.colors.primary.transparentBg};
    cursor: pointer;
    color: ${theme.colors.primary.black};
    border: 1px solid ${theme.colors.primary.transparentBg};
  }
  &.red {
    display: flex;
    align-items: center;
    color: ${theme.colors.secondary.red100};
    &:hover {
      color: ${theme.colors.secondary.red100};
    }
    svg {
      path {
        fill: ${theme.colors.secondary.red100} !important;
      }
    }
  }
  &.disabled {
    cursor: not-allowed;
    color: ${theme.colors.primary.transparentBorder} !important;
    &:hover {
      background: ${theme.colors.primary.white};
    }
    svg {
      path {
        stroke: ${theme.colors.primary.transparentBorder} !important;
      }
      rect {
        stroke: ${theme.colors.primary.transparentBorder} !important;
      }
    }
  }
`;
